export default __webpack_public_path__ + "static/media/poi.2eed60f6.png";